import { PROJECT_URL_PATH_SEGMENT } from '@neptune/shared/core-project-domain';
import { makeEnterpriseRoute } from '@neptune/shared/enterprise-context-business-logic';
import { AppRoute } from '@neptune/shared/routing-domain';

// router5 treats dots in route names as nesting, so the name has none (both routes are top level).
export const REPORT_WIDGET_EMBED_ROUTE = 'slack-embed-report-widget';

const REPORT_WIDGET_EMBED_PATH = '/reports/:reportId/version/:versionId/widgets/:widgetId?:render';

export const reportWidgetEmbedRoutes: AppRoute[] = [
  {
    name: REPORT_WIDGET_EMBED_ROUTE,
    path: `/embed/:organizationName/${PROJECT_URL_PATH_SEGMENT}${REPORT_WIDGET_EMBED_PATH}`,
  },
  makeEnterpriseRoute({
    name: REPORT_WIDGET_EMBED_ROUTE,
    path: `/embed/o/:organizationName/org/${PROJECT_URL_PATH_SEGMENT}${REPORT_WIDGET_EMBED_PATH}`,
  }),
];
